module.exports = __webpack_public_path__ + "static/media/hu.cc4edf3b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/hu.svg
// module id = 2112
// module chunks = 0